import liff from "@line/liff";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { bindLineAccount } from "../service/AuthService";
import type { APIResult, User } from "../my-type";
import { actionCreators } from "../state";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { Loader, Message, Text } from "rsuite";
import { isAllowedRiderTeamUser, RIDER_TEAM_ACCESS_DENIED_MESSAGE } from "../util/riderAccess";


export default function LiffCallback() {
  const [message, setMessage] = useState<string>("");
  let [searchParams] = useSearchParams()
  const location = searchParams.get("location");
  const { teamCode } = useParams();
  const [isShowLoading, setIsShowLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { updateUser } = bindActionCreators(actionCreators, dispatch);
  const navigate = useNavigate();


  const mapingAccount = async () => {
    const accessToken = liff.getAccessToken();
    const idToken = liff.getIDToken();


    if (idToken && accessToken) {

      if (!teamCode) {
        setMessage("登入時發生錯誤,team code not found in url");
        return;
      }

      bindAccount(accessToken, idToken, teamCode, null, 3600);
    }
  }

  useEffect(() => {
    const envLiffId = process.env[`REACT_APP_LINE_LIFF_ID_${teamCode}`];
    liff
      .init({
        liffId: envLiffId!, // Use own liffId
      })
      .then(() => {
        // Start to use liff's api
        setMessage("LIFF init success in LiffCallback page");
        if (liff.isInClient() && liff.isLoggedIn()) {
          mapingAccount();
        } else {
          //redirect to loing page
          navigate("/rider/order/create");
        }
      })
      .catch((err) => {
        // Error happens during initialization
        console.log(err.code, err.message);
        alert(err.message);
      });
  })

  const bindAccount = async (accessToken: string, idToken: string, teamCode: string, refreshToken: string | null, expires_in: number) => {
    setIsShowLoading(true);
    let callResultData: APIResult = await bindLineAccount(idToken, teamCode);
    console.log(callResultData);
    setIsShowLoading(false);
    if (callResultData.statusCode === 0) {
      //alert(callResultData.message);
      //setMessage("取得LINE身份資料時發生錯誤，請重新登入LINE");
      setMessage(callResultData.message);
    } else if (callResultData.statusCode === 1) {
      //redirect to home
      //alert(callResultData);
      let user: User = callResultData.data;
      console.log(user);

      if (!isAllowedRiderTeamUser(user)) {
        updateUser(null);
        setMessage(RIDER_TEAM_ACCESS_DENIED_MESSAGE);
        return;
      }

      setMessage("登入成功");
      console.log(location);
      user.lineAccessToken = accessToken;
      user.tokenExpiry = new Date(new Date().getTime() + expires_in * 1000);
      user.refreshToken = refreshToken ? refreshToken : "";

      updateUser(user);

      if (!location) {
        navigate("/");
      } else {
        //const redirect = searchParams.get("location") || "/";
        // 把除了 redirect 以外的參數都帶回去（例如 actype）
        const entries = Array.from(searchParams.entries()).filter(([k]) => k !== "location");
        const qs = new URLSearchParams(entries).toString();

        navigate(location + (qs ? `?${qs}` : ""), { replace: true });
      }
    } else {
      setMessage("登入時發生錯誤");
      alert(callResultData);
    }
  }



  return (
    <div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {isShowLoading && <Loader content="Liff callback 登入中..." />}
      {message === RIDER_TEAM_ACCESS_DENIED_MESSAGE ? (
        <Message showIcon type="warning">
          {message}
        </Message>
      ) : (
        <Text muted>{message}</Text>
      )}
    </div>
  );


}
